import { IBody } from "./IBody";
/**
 * Represents a 3D model
 */
export class Model {
	public bodies: IBody[] = [];

	/**
	 * Gets or sets the length of the bounding box in mm.
	 * In case of an assembly, this includes all bodies at their positions.
	 */
	public length: number = 0;

	/**
	 * Gets width of bounding box in mm.
	 */
	public width: number = 0;

	/**
	 * Gets or sets heigth of bounding box in mm.
	 */
	public height: number = 0;

	/**
	 * Gets or sets the values of the 4x4 transformation matrix that was applied to the complete model.
	 */
	public transformationMatrix: number[] = [];

	/**
	 * Gets or sets the last used group id. This simplifies the process of calculate this number.
	 */
	public lastGroupId: number = 0;
}
